import { GiftWrapperBoxModel } from '../model/basket-overview-gift-form.model';

export class SaveBasketGiftPackageAction {
  static type = '[BASKET] Save gift packages';

  constructor(readonly packages: GiftWrapperBoxModel[]) {}
}
